/**
 * ValueCard — Horizontal card with label and value on a tinted background
 *
 * Used for: inventory value summaries (cost value, retail value, potential profit)
 * From: InventoryReportsScreen valueCard pattern
 */
import { styled, XStack, Text as TamaguiText, type GetProps } from 'tamagui'

const ValueCardFrame = styled(XStack, {
  name: 'ValueCard',
  ai: 'center',
  jc: 'space-between',
  p: '$md',
  br: '$lg',
  bg: '$backgroundSecondary',
})

const ValueLabel = styled(TamaguiText, {
  name: 'ValueLabel',
  fontFamily: '$body',
  fontSize: 14,
  fontWeight: '500',
  color: '$color',
})

const ValueAmount = styled(TamaguiText, {
  name: 'ValueAmount',
  fontFamily: '$body',
  fontSize: 20,
  fontWeight: '700',
  color: '$color',
})

type ValueCardFrameProps = GetProps<typeof ValueCardFrame>

interface ValueCardProps extends ValueCardFrameProps {
  label: string
  value: string
  /** Override value text color */
  valueColor?: string
}

export const ValueCard = ValueCardFrame.styleable<ValueCardProps>(
  ({ label, value, valueColor, ...props }, ref) => {
    return (
      <ValueCardFrame ref={ref} {...props}>
        <ValueLabel>{label}</ValueLabel>
        <ValueAmount {...(valueColor ? { color: valueColor as any } : {})}>
          {value}
        </ValueAmount>
      </ValueCardFrame>
    )
  },
)
